/* eslint-disable react/prop-types */
// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/item.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/step.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import 'styles/App.css'
import './style.scss'
import { hot } from 'react-hot-loader'
import Masthead from '@ta-interaktiv/react-polymorphic-masthead'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import UserFeedback from '@ta-interaktiv/react-user-feedback'
import PolymorphicShareButtons from '@ta-interaktiv/react-polymorphic-share-buttons'
import { displayTypes } from '@ta-interaktiv/react-share-buttons'
import { PolymorphicTracking } from '@ta-interaktiv/react-polymorphic-tracking'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import Waypoint from 'react-waypoint'
import Scrollchor from 'react-scrollchor'

type Props = {
  articleId: string,
  questions: string[]
}

class AppComponent extends React.Component<Props> {
  static defaultProps = {
    articleId: '25474307',
    questions: [
      'Wie oft machte Trump falsche Aussagen?',
      'Wie gut kommt Trump beim Volk an?',
      'Wie hat sich die Wirtschaft unter Trump entwickelt?',
      'Wie viele seiner Versprechen konnte er umsetzen?',
      'Wie oft spielte Trump Golf?'
    ]
  }

  constructor (props) {
    super(props)
    this.trackNavClicks = this.trackNavClicks.bind(this)
    this.trackTopClicks = this.trackTopClicks.bind(this)
  }

  trackNavClicks (e) {
    let clickedText = e.currentTarget.firstChild.nodeValue
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'question: ' + clickedText
    })
  }

  trackTopClicks (e) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toTop: '
    })
  }

  render () {
    return (
      <div className='index'>
        <Masthead articleID={this.props.articleId} />
        <header className='ui vertical segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              365 Tage Trump
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
                Was hat Donald Trump in seinem ersten Jahr als Präsident
                erreicht? Wie oft machte er falsche Aussagen? Wie entwickelte
                sich die Wirtschaft? Wie viel Zeit verbrachte er auf dem
                Golfplatz?
              </div>
            </h2>
            <p className='ta author'>Von Interaktiv-Team und Infografik</p>
          </div>
        </header>

        <Waypoint
          scrollableAncestor={window}
          onLeave={({ previousPosition, currentPosition }) => {
            if (
              previousPosition === Waypoint.inside &&
              currentPosition === Waypoint.above
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'startReading'
              })
            }
          }}
        />

        <nav className='ui vertical fitted inverted segment dark-grey background'>
          <div className='ui text container'>
            <p>
              Ein gespaltenes Land und eine irritierte Welt, viele Lügen und
              noch mehr Tweets, eine boomende Wirtschaft, Wortgefechte mit Kim
              Jong-un und den «Fake News-Medien», eine grosse Steuerreform und
              Turbulenzen in der Russland-Affäre: Das ist die Präsidentschaft
              von Donald Trump. Zahlen und Grafiken zu seinem ersten Amtsjahr.
            </p>
            <ul className='nav' id='nav'>
              <a href='#question-1'>
                <Scrollchor to='#question-1'>
                  <li
                    className='question-link ui items unstackable'
                    onClick={this.trackNavClicks}
                  >
                    <div className='item'>
                      <span style={{ paddingRight: '5px' }}>1.</span>
                      <div className='content'>{this.props.questions[0]}</div>
                    </div>
                  </li>
                </Scrollchor>
              </a>
              <a href='#question-2'>
                <Scrollchor to='#question-2'>
                  <li
                    className='question-link ui items unstackable'
                    onClick={this.trackNavClicks}
                  >
                    <div className='item'>
                      <span style={{ paddingRight: '5px' }}>2.</span>
                      <div className='content'>{this.props.questions[1]}</div>
                    </div>
                  </li>
                </Scrollchor>
              </a>
              <a href='#question-3'>
                <Scrollchor to='#question-3'>
                  <li
                    className='question-link ui unstackable items'
                    onClick={this.trackNavClicks}
                  >
                    <div className='item'>
                      <span style={{ paddingRight: '5px' }}>3.</span>
                      <div className='content'>{this.props.questions[2]}</div>
                    </div>
                  </li>
                </Scrollchor>
              </a>
              <a href='#question-4'>
                <Scrollchor to='#question-4'>
                  <li
                    className='question-link ui unstackable items'
                    onClick={this.trackNavClicks}
                  >
                    <div className='item'>
                      <span style={{ paddingRight: '5px' }}>4.</span>
                      <div className='content'>{this.props.questions[3]}</div>
                    </div>
                  </li>
                </Scrollchor>
              </a>
              <a href='#question-5'>
                <Scrollchor to='#question-5'>
                  <li
                    className='question-link ui unstackable items'
                    onClick={this.trackNavClicks}
                  >
                    <div className='item'>
                      <span style={{ paddingRight: '5px' }}>5.</span>
                      <div className='content'>{this.props.questions[4]}</div>
                    </div>
                  </li>
                </Scrollchor>
              </a>
            </ul>
            <FeedbackMessage mailTo='interaktiv@tages-anzeiger.ch' />
          </div>
        </nav>

        <main className='ui vertical very fitted inverted segment dark-grey background'>
          <div className='ui question container' id='question-1'>
            <h2>
              <span className='title-text'>1. {this.props.questions[0]}</span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
            <div className='ui text container no-marg'>
              <p>
                Donald Trump hat ein abenteuerliches Verhältnis zur Wahrheit.
                Was seine Berater beschönigend als «alternative Fakten»
                bezeichnen, sind nichts anderes als Lügen oder Falschaussagen.{' '}
                <a
                  className='external link'
                  href='https://www.washingtonpost.com/graphics/politics/trump-claims-database/?tid=a_inl&utm_term=.dadc5af4627c'
                  target='_blank'
                >
                  <i className='icon external' />Die Fakten-Checker der
                  «Washington Post»
                </a>{' '}
                machen sich die Mühe, tagtäglich Aussagen und Tweets des
                Präsidenten zu überprüfen. Dabei geben sie auch an, wie häufig
                und an welchen Tagen Trump seine Behauptungen wiederholt oder
                aber verändert. Das Resultat: Im ersten Amtsjahr hat Trump
                2001-mal gelogen oder irreführende Aussagen gemacht.{' '}
              </p>
            </div>
            <img
              src={
                window.outerWidth < 599
                  ? require('./imgs/claims-mobile.svg')
                  : require('./imgs/claims-desktop.svg')
              }
              style={{ margin: '30px auto 0 auto' }}
            />
            <p
              className='progress bar text source full-width'
              style={{ marginBottom: '2em' }}
            >
              Quelle: US Bureau of Labor Statistics
            </p>
            <div className='ui text container no-marg'>
              <p>
                Trump bejubelt gerne angebliche Erfolge seiner Regierung. Am 15.
                August 2017 sprach er zum Beispiel von der «niedrigsten
                Arbeitslosenquote in der US-amerikanischen Geschichte», drei
                Tage zuvor hatte er noch von der niedrigsten Arbeitslosenquote
                «seit fast 17 Jahren» gesprochen. Sehr gerne kommentiert Trump
                die Entwicklung des Aktienindex Dow Jones, der von Rekord zu
                Rekord eilt. Bei diesem Thema hat er sich 91-mal eine Lüge oder
                Falschaussage geleistet. Die Statistik der Fakten-Checker
                spiegelt die politische Debatte. Wenn es um die Abschaffung von
                Obamacare geht oder die Russland-Affäre, häufen sich die
                wahrheitswidrigen Aussagen von Trump.
              </p>
              <div
                className='ui vertical aligned fitted segment'
                style={{ color: 'white' }}
              >
                <p
                  className='progress bar text'
                  style={{
                    textAlign: 'left',
                    color: 'white',
                    marginBottom: '0'
                  }}
                >
                  <strong>Die drei häufigsten falschen Behauptungen:</strong>
                </p>
                <h3 className='trump quote'>
                  «Die Aktienkurse sind auf Rekordniveau. Das bedeutet mehr
                  Jobs.»
                </h3>
                <p className='quote label'>91 Mal wiederholt</p>
                <h3 className='trump quote'>«Obamacare ist quasi tot.»</h3>
                <p className='quote label'>61 Mal wiederholt</p>
                <h3 className='trump quote'>
                  «Wir streichen Auflagen, deswegen kommen Jobs in der
                  Autoindustrie zurück.»
                </h3>
                <p className='quote label'>61 Mal wiederholt</p>
                <br />
                <p>
                  Den Fact-Checkern von{' '}
                  <a
                    href='http://www.politifact.com/personalities/donald-trump/'
                    target='_blank'
                    className='external link'
                  >
                    <i className='icon external' />Politifact
                  </a>{' '}
                  zufolge sind sogar zwei Drittel der überprüften Aussagen
                  Trumps «mehr oder weniger oder komplett falsch».
                </p>
              </div>
            </div>
          </div>
        </main>
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'question1read'
              })
            }
          }}
        />
        <main className='ui vertical very fitted inverted segment dark-grey background'>
          <div className='ui question container' id='question-2'>
            <h2>
              <span className='title-text'>2. {this.props.questions[1]}</span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
            <div className='ui text container no-marg'>
              <p>
                Umfragen, welche Donald Trumps Leistung bewerten, zeigen, wie
                einmalig seine Präsidentschaft ist. Das amerikanische
                Forschungsinstitut Gallup berechnete auf der Grundlage mehrerer
                Erhebungen, dass{' '}
                <span className='trump underlined'>
                  57 Prozent der Bevölkerung die Arbeit von Trump missbilligen
                </span>{' '}
                (Stand: Januar 2018). Das ist deutlich mehr als etwa George W.
                Bush (11%), Bill Clinton (40%) oder Barack Obama (43%) nach
                einem Jahr im Amt vorwiesen. Bei Trump handelt sich insgesamt um
                die schlechtesten Werte für einen Präsidenten zu diesem
                Zeitpunkt in den 70 Jahren, seit es derartige Umfragen gibt.
              </p>
              <p className='progress bar text white'>
                <strong>Ablehnung in der Bevölkerung, in Prozent</strong>
              </p>
              <img
                className='image-padded'
                src={require('./imgs/Ablehnung.svg')}
                width='100%'
              />
              <p className='progress bar text source'>Quelle: Gallup</p>
              <p>
                Fast jeder Präsident erreicht irgendwann einmal den Punkt, an
                welchem mindestens 50 Prozent der Bevölkerung seine Arbeit
                missbilligen. Für Trump ist dieser Moment jedoch früher gekommen
                als für alle anderen. Während George W. Bush drei Jahre
                brauchte, um das Volk gegen sich aufzubringen,{' '}
                <a
                  className='external link'
                  href='https://www.tagesanzeiger.ch/ausland/amerika/nach-8-tagen-hat-er-schon-die-mehrheit-gegen-sich-rekord/story/23278078'
                  target='_blank'
                >
                  <i className='external icon' />
                  <span>gelang Trump dies in nur acht Tagen</span>
                </a>.
              </p>
              <p>
                Fragt man das Volk nach der Zustimmung für Trump, sieht es so
                aus: Nur 39 Prozent der Amerikaner sind nach einem Jahr mit
                seiner Arbeit zufrieden. Obama hatte zu diesem Zeitpunkt eine
                Zustimmungsrate von 50 Prozent, W. Bush hohe 83 Prozent (wegen
                der Folgen von 9/11) und Clinton 54 Prozent. Für die
                Republikaner im Kongress ist das vor der Zwischenwahl im
                November 2018 kein gutes Signal. Seit 1950 hat keine Partei die
                Kontrolle über das Repräsentantenhaus behalten, wenn die
                Zustimmungsquote des Präsidenten unter 40 Prozent lag.
              </p>
              <p>
                Immerhin im eigenen Lager kommt Trump aber noch bestens an. 82
                Prozent der Republikaner sind zufrieden mit seinen Leistungen im
                Amt. Bei den Demokraten beträgt die Zustimmung lediglich 9
                Prozent.
              </p>
            </div>
          </div>
        </main>
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'question2read'
              })
            }
          }}
        />
        <main className='ui vertical very fitted inverted segment dark-grey background'>
          <div className='ui question container' id='question-3'>
            <h2>
              <span className='title-text'>3. {this.props.questions[2]}</span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
            <div className='ui text container no-marg'>
              <p>
                Er werde die US-Wirtschaft wieder auf Vordermann bringen,
                versprach Donald Trump im Wahlkampf immer wieder und brachte
                damit viele Unentschlossene dazu, ihm die Stimme zu geben. So
                war beispielsweise von einem Wachstum bis zu 5 Prozent die Rede
                sowie von der Behebung des Handelsdefizites des Landes.
              </p>

              <p>
                Jetzt, ein Jahr, nachdem Trump das Weisse Haus übernahm, ist es
                Zeit, Zwischenbilanz zu ziehen. Wir haben uns sechs zentrale
                Wirtschaftsbereiche angeschaut, um zu analysieren, ob Trump
                seine Versprechen einhalten kann, die er während des Wahlkampfs
                und in den ersten Monaten als Präsident machte. Als Vergleich
                dient die wirtschaftliche Entwicklung während der letzten
                Amtsdauer seines Vorgängers Barack Obama.
              </p>
              <div
                className='ui vertical left aligned fitted segment'
                style={{ color: 'white' }}
              >
                <p
                  className='progress bar text'
                  style={{
                    textAlign: 'left',
                    color: 'white',
                    marginBottom: '0'
                  }}
                >
                  <strong>Bruttoinlandprodukt (BIP)</strong>
                </p>
                <p>
                  2016 wuchs die US-Wirtschaft nur um 1,6 Prozent. Es war das
                  schlechteste Ergebnis seit fünf Jahren, aus Sicht der meisten
                  Experten aber mit dem weltweiten Zustand der Wirtschaft zu
                  erklären. Viele Analysten sahen die negative Entwicklung
                  aufgrund des eingebrochenen Ölpreises kommen. Doch Trump
                  sprach in erster Linie von einem Versagen seines Vorgängers
                  Obama.
                </p>

                <p>
                  Ende April 2017 gab sich Trump überzeugt, dass sein Land
                  imstande sei, das Bruttoinlandprodukt massiv zu erhöhen. «Ich
                  glaube wirklich daran. Wir sagen momentan 3 (Prozent), aber
                  ich sage 4 in den nächsten paar Jahren. Und es gibt keinen
                  Grund, warum wir dereinst nicht 5 oder mehr erreichen
                  könnten», sagte er in einem Interview mit Fox News.
                </p>
                <p className='progress bar text white'>
                  <strong>Wachstum des BIP pro Quartal, in Prozent</strong>
                </p>
                <img
                  className='image-padded'
                  src={require('./imgs/Bip.svg')}
                  width='100%'
                />
                <p className='progress bar text source'>
                  Quelle: Tradingeconomics
                </p>

                <p>
                  Seit Trumps Amtsantritt hat sich das BIP tatsächlich positiv
                  entwickelt. 3,1 Prozent wuchs es im zweiten Quartal 2017 und
                  3,2 Prozent im dritten. Viele Ökonomen anerkennen, dass Trumps
                  Bestrebungen – etwa die Senkung der Unternehmenssteuer von 35
                  auf 20 Prozent – der US-Wirtschaft einen leichten Schub
                  verliehen haben. Längerfristig dürften diese Massnahmen
                  allerdings nur noch einen geringen Einfluss haben. Experten
                  gehen für 2019 und darüber hinaus von einem Wachstum zwischen
                  2 und 2,25 Prozent aus. Das entspricht ungefähr dem
                  Durchschnitt der Jahre 2012–2016 unter Obama. Trumps Prognose
                  war demnach etwas gar zuversichtlich.
                </p>
              </div>
              <div
                className='ui vertical left aligned fitted segment'
                style={{ color: 'white' }}
              >
                <p
                  className='progress bar text'
                  style={{
                    textAlign: 'left',
                    color: 'white',
                    marginBottom: '0'
                  }}
                >
                  <strong>Konsumentenpreisindex</strong>
                </p>
                <p>
                  Die USA erlebten seit den 1990er-Jahren nur eine leichte
                  Inflation. Einige Ökonomen befürchten, dass die Kombination
                  von Trumps verschiedenen Vorschlägen zu schneller steigenden
                  Preisen für Waren und Dienstleistungen führen könnte, wenn sie
                  umgesetzt werden sollten.
                </p>
                <p className='progress bar text white'>
                  <strong>Konsumentenpreisindex, in Prozent</strong>
                </p>
                <img
                  className='image-padded'
                  src={require('./imgs/Konsumentenpreis.svg')}
                  width='100%'
                />
                <p className='progress bar text source'>
                  Quelle: US Bureau of Labor Statistics
                </p>

                <p>
                  Wie sich der Konsumentenpreisindex unter Trumps
                  Präsidentschaft entwickeln wird, ist schwierig abzuschätzen.
                  Zwischen Februar und Juni sank er von 2,8 auf 1,6 Prozent. Bis
                  Ende 2017 stieg er allerdings wieder auf 2,1 Prozent. Bei
                  einer hohen Inflation gelten Politiker schnell als Sündenbock
                  für die erodierende Kaufkraft von Haushalten – besonders, wenn
                  gleichzeitig die Löhne stagnieren.
                </p>
              </div>
              <div
                className='ui vertical left aligned fitted segment'
                style={{ color: 'white' }}
              >
                <p
                  className='progress bar text'
                  style={{
                    textAlign: 'left',
                    color: 'white',
                    marginBottom: '0'
                  }}
                >
                  <strong>Anzahl Beschäftigte und Arbeitslosenquote</strong>
                </p>
                <p>
                  Die Zahl der Beschäftigten ausserhalb der Landwirtschaft, in
                  den USA als «nonfarm payrolls» bezeichnet, stieg schon unter
                  Obama kontinuierlich. 2016 wurden pro Monat durchschnittlich
                  gut 186’000 neue Jobs geschaffen. Mit Trump als Präsident
                  setzt sich dieser Trend fort, wenngleich weniger dynamisch.
                  2017 stieg die Zahl der beschäftigten US-Amerikanerinnen und
                  -Amerikaner um monatlich 171’000.
                </p>

                <p className='progress bar text white'>
                  <strong>
                    Monatlich geschaffene Arbeitsplätze (ohne Landwirtschaft)
                  </strong>
                </p>
                <img
                  className='image-padded'
                  src={require('./imgs/Beschäftigte.svg')}
                  width='100%'
                />
                <p className='progress bar text source'>
                  Quelle: Tradingeconomics
                </p>

                <p>
                  Bei der Arbeitslosenquote sieht es ähnlich aus: Die positive
                  Entwicklung, die schon seit 2012 anhält, setzte sich auch im
                  vergangenen Jahr fort. Unter Trump fiel die Rate um 0,7 auf
                  4,1 Prozent Ende Dezember.
                </p>

                <p className='progress bar text white'>
                  <strong>Arbeitslosenquote, in Prozent</strong>
                </p>
                <img
                  className='image-padded'
                  src={require('./imgs/Arbeitslosenquote.svg')}
                  width='100%'
                />
                <p className='progress bar text source'>
                  Quelle: Tradingeconomics
                </p>

                <p>
                  Trump bezeichnete die Arbeitslosenquote aber auch schon als
                  «unsinnig», weil dabei nur diejenigen Amerikanerinnen und
                  Amerikaner gezählt werden, die aktiv einen Job suchen. Beim
                  Rest handelt es sich in den meisten Fällen um Personen im
                  Ruhestand, solche, die sich um die Familie kümmern oder
                  studieren.
                </p>
              </div>

              <div
                className='ui vertical left aligned fitted segment'
                style={{ color: 'white' }}
              >
                <p
                  className='progress bar text'
                  style={{
                    textAlign: 'left',
                    color: 'white',
                    marginBottom: '0'
                  }}
                >
                  <strong>Arbeitsplätze im Industriesektor</strong>
                </p>
                <p>
                  Für Trump ist klar: Die USA können sich nur erneuern, wenn es
                  zu einem Aufschwung der Produktion im Land kommt. Dank seiner
                  Handelspolitik sollen wieder viel mehr Arbeitsplätze in der
                  Industrie geschaffen werden. Und diese Entwicklung hat er in
                  seinem ersten Amtsjahr auch angestossen.
                </p>

                <p className='progress bar text white'>
                  <strong>Monatlich geschaffene Industriearbeitsplätze</strong>
                </p>
                <img
                  className='image-padded'
                  src={require('./imgs/Industriearbeitsplätze.svg')}
                  width='100%'
                />
                <p className='progress bar text source'>
                  Quelle: US Bureau of Labor Statistics
                </p>

                <p>
                  Für Trump ist klar: Die USA können sich nur erneuern, wenn es
                  zu einem Aufschwung der Produktion im Land kommt. Dank seiner
                  Handelspolitik sollen wieder viel mehr Arbeitsplätze in der
                  Industrie geschaffen werden. Und diese Entwicklung hat er in
                  seinem ersten Amtsjahr auch angestossen.
                </p>

                <p>
                  Experten sind sich indes uneinig über das Potenzial des
                  Wachstums von Jobs im Fertigungsbereich. Selbst wenn das
                  Produktionsvolumen steigen sollte, werden in Zukunft aufgrund
                  der Automatisierung und besseren Managements voraussichtlich
                  weniger Arbeitskräfte eingesetzt.
                </p>
              </div>

              <div
                className='ui vertical left aligned fitted segment'
                style={{ color: 'white' }}
              >
                <p
                  className='progress bar text'
                  style={{
                    textAlign: 'left',
                    color: 'white',
                    marginBottom: '0'
                  }}
                >
                  <strong>Handelsdefizit</strong>
                </p>
                <p>
                  Trump und einige Mitglieder seines Teams betrachten
                  Handelsdefizite als etwas von Natur aus Schlechtes, auch wenn
                  die meisten Ökonomen anderer Auffassung sind. «Die Jobs und
                  der Wohlstand wurden unserem Land entrissen. Jahr für Jahr,
                  Jahrzehnt für Jahrzehnt Handelsdefizit über Handelsdefizit»,
                  regte sich der US-Präsident im März 2017 auf. Das Ziel der
                  Handelspolitik seiner Regierung sei es, das Defizit zu
                  verkleinern oder ganz zu eliminieren.
                </p>

                <p>
                  Bis jetzt ist diesbezüglich noch nicht viel passiert – im
                  Gegenteil: Bis im November 2017 stieg das Handelsdefizit auf
                  über 50 Milliarden US-Dollar. So gross war es zuletzt Anfang
                  2012. Trump macht unvorteilhafte Handelsabkommen und
                  Missbrauch durch China und andere Länder dafür verantwortlich.
                </p>
              </div>
            </div>
          </div>
        </main>
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'question3read'
              })
            }
          }}
        />
        <main className='ui vertical very fitted inverted segment dark-grey background'>
          <div className='ui question container' id='question-4'>
            <h2>
              <span className='title-text'>4. {this.props.questions[3]}</span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
            <div className='ui container no-marg'>
              <p
                className='progress bar text'
                style={{ fontFamily: 'Georgia', fontSize: '1rem' }}
              >
                Donald Trump hatte im Wahlkampf viel versprochen. Die chaotische
                Regierungsführung sowie Widerstände im US-Kongress und Klagen
                vor Gerichten verhindern allerdings die rasche Umsetzung von
                fast allen zentralen Wahlversprechen. Trumps innenpolitische
                Erfolgsbilanz nach dem ersten Amtsjahr fällt eher bescheiden
                aus. Zum ersten Jahrestag der Trump-Präsidentschaft ist es zum
                Shutdown gekommen. Wegen eines Streits um den Haushalt müssen
                Teile der öffentlichen Verwaltung per sofort heruntergefahren
                werden.
              </p>
              <div
                className='ui center aligned very fitted vertical segment'
                style={{ paddingBottom: '0', display: 'none' }}
              >
                <p style={{ color: 'white' }}>
                  <strong>Lesebeispiel:</strong>
                </p>
                <div
                  className='ui mini top attached steps'
                  style={{ marginBottom: '30px' }}
                >
                  <div className='yellow step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>
                        Schritt wurde während Trumps Amtszeit erleidgt
                      </div>
                    </div>
                  </div>
                  <div className='yellow step'>
                    <div className='content'>
                      <div className='title'>Bisher nicht erledigt</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='ui center aligned fitted vertical segment'>
                <p
                  className='progress bar text'
                  style={{
                    textAlign: 'left',
                    color: 'white',
                    marginBottom: '0'
                  }}
                >
                  <strong>Steuerreform</strong>
                </p>
                <p
                  className='progress bar text'
                  style={{ textAlign: 'left', color: 'white' }}
                >
                  Mit der Verabschiedung der Steuerreform Ende 2017 hat Donald
                  Trump seinen bisher grössten innenpolitischen Erfolg errungen.
                  Die Unternehmenssteuer sinkt drastisch, ebenso der Höchstsatz
                  bei der Einkommenssteuer. Trump preist die Reform als
                  Jobmaschine, Kritiker sprechen von einem Geschenk für die
                  Reichen.
                </p>
                <div className='ui mini top attached steps'>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'> Gesetzesentwurf</div>
                    </div>
                  </div>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>Zustimmung Repräsentantenhaus</div>
                    </div>
                  </div>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>Zustimmung Senat</div>
                    </div>
                  </div>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>Inkraftsetzung Gesetz</div>
                    </div>
                  </div>
                </div>
              </div>
              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'progressbar1read'
                    })
                  }
                }}
              />
              <div className='progress bar text ui divider' />
              <div className='ui center aligned fitted vertical segment steps-container'>
                <p
                  className='progress bar text'
                  style={{ textAlign: 'left', color: 'white' }}
                >
                  <p
                    className='progress bar text'
                    style={{
                      textAlign: 'left',
                      color: 'white',
                      marginBottom: '0'
                    }}
                  >
                    <strong>Bau der Mexiko-Mauer</strong>
                  </p>
                  Im Wahlkampf versprach Trump eine «schöne Mauer» an der
                  mexikanischen Grenze gegen die illegale Einwanderung. Dass
                  Trump die Mexikaner dazu bringen kann, die Mauer zu
                  finanzieren, ist unrealistisch. Trump hofft nun, dass der
                  Kongress das für den Mauerbau nötige Geld bewilligt. Die
                  Mexiko-Grenzmauer stösst weiterhin auf grössten Widerstand von
                  verschiedenen Seiten.
                </p>
                <div className='ui mini top attached steps'>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>Executive Order</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Zustimmung Repräsentantenhaus</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Zustimmung Senat</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Inkraftsetzung Gesetz</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Mauerbau</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Mexiko zahlt</div>
                    </div>
                  </div>
                </div>
              </div>
              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'progressbar2read'
                    })
                  }
                }}
              />
              <div className='progress bar text ui divider' />
              <div className='ui center aligned fitted vertical segment steps-container steps-container steps-container steps-container'>
                <p
                  className='progress bar text'
                  style={{ textAlign: 'left', color: 'white' }}
                >
                  <p
                    className='progress bar text'
                    style={{
                      textAlign: 'left',
                      color: 'white',
                      marginBottom: '0'
                    }}
                  >
                    <strong>Abschaffung Obamacare</strong>
                  </p>
                  Trump hat mehrere Versuche unternommen, das
                  Krankenversicherungssystem seines Vorgängers Barack Obama
                  abzuschaffen. Er scheiterte aber mehrmals an der Uneinigkeit
                  seiner Republikanischen Partei. Eine Änderung des Gesetzes hat
                  immerhin das Repräsentantenhaus passiert. Die Abschaffung
                  respektive Reform von Obamacare bleibt ein grosses Thema.
                </p>
                <div className='ui mini top attached steps'>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>Executive Order</div>
                    </div>
                  </div>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>4. Gesetzesentwurf</div>
                    </div>
                  </div>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>Zustimmung Repräsentantenhaus</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Zustimmung Senat</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Inkraftsetzung Gesetz</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='progress bar text ui divider' />
              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'progressbar3read'
                    })
                  }
                }}
              />
              <div className='ui center aligned fitted vertical segment steps-container'>
                <p
                  className='progress bar text'
                  style={{ textAlign: 'left', color: 'white' }}
                >
                  <p
                    className='progress bar text'
                    style={{
                      textAlign: 'left',
                      color: 'white',
                      marginBottom: '0'
                    }}
                  >
                    <strong>Einreisestopp für Muslime</strong>
                  </p>
                  Trumps Einreisebann gegen Bürger von sechs mehrheitlich
                  muslimischen Ländern beschäftigt seit bald einem Jahr die
                  Gerichte. Nach erfolgreichen Klagen in mehreren
                  US-Bundesstaaten gelang es dem Präsidenten erst im dritten
                  Anlauf, die harten Einreisebeschränkungen durchzusetzen. Dies
                  gilt aber nur vorläufig, weil definitive Gerichtsentscheide
                  ausstehen.
                </p>
                <div className='ui mini top attached steps'>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>Executive Order</div>
                    </div>
                  </div>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>
                        Juristische Blockade nach Klagen
                      </div>
                    </div>
                  </div>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>Executive Order</div>
                    </div>
                  </div>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>Hängige Klagen</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Entscheid Supreme Court</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='progress bar text ui divider' />
              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'progressbar4read'
                    })
                  }
                }}
              />
              <div className='ui center aligned fitted vertical segment steps-container'>
                <p
                  className='progress bar text'
                  style={{ textAlign: 'left', color: 'white' }}
                >
                  <p
                    className='progress bar text'
                    style={{
                      textAlign: 'left',
                      color: 'white',
                      marginBottom: '0'
                    }}
                  >
                    <strong>Besteuerung von Importen</strong>
                  </p>
                  Trump wollte alle Importe mit einem Steuerzuschlag von 20
                  Prozent belegen. Eine spezielle Besteuerung hatte er für
                  mexikanische Einfuhren vorgeschlagen, um die geplante Mauer zu
                  finanzieren. Aus all dem wird nichts, denn selbst seine
                  Republikaner wollen nicht mitmachen.
                </p>
                <div className='ui mini top attached steps'>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Gesetzesentwurf</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Zustimmung Repräsentantenhaus</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Zustimmung Senat</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Inkraftsetzung Gesetz</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='progress bar text ui divider' />
              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'progressbar5read'
                    })
                  }
                }}
              />
              <div className='ui center aligned fitted vertical segment steps-container'>
                <p
                  className='progress bar text'
                  style={{ textAlign: 'left', color: 'white' }}
                >
                  <p
                    className='progress bar text'
                    style={{
                      textAlign: 'left',
                      color: 'white',
                      marginBottom: '0'
                    }}
                  >
                    <strong>Abschiebung von Einwanderern</strong>
                  </p>Trump will bis zu 800’000 junge Migranten ohne Papiere
                  abschieben. Das Schutzprogramm Daca für die sogenannten
                  Dreamer wird am 5. März 2018 auslaufen. Die Demokraten wollen
                  einem sehr wichtigen Ausgabengesetz der Republikaner nur dann
                  zustimmen, wenn der Abschiebeschutz für die Dreamer verlängert
                  wird. Der Kongress ringt derzeit um einen Deal.
                </p>
                <div className='ui mini top attached steps'>
                  <div className='yellow step'>
                    <i className='mini checkmark box icon' />
                    <div className='content'>
                      <div className='title'>Executive Order</div>
                    </div>
                  </div>
                  <div className='yellow step'>
                    <i className='icon checkmark box' />
                    <div className='content'>
                      <div className='title'>Zustimmung Repräsentantenhaus</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Zustimmung Senat</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Inkraftsetzung Gesetz</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='progress bar text ui divider' />
              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'progressbar6read'
                    })
                  }
                }}
              />
              <div className='ui center aligned fitted vertical segment steps-container'>
                <p
                  className='progress bar text'
                  style={{ textAlign: 'left', color: 'white' }}
                >
                  <p
                    className='progress bar text'
                    style={{
                      textAlign: 'left',
                      color: 'white',
                      marginBottom: '0'
                    }}
                  >
                    <strong>Investitionen in Infrastruktur</strong>
                  </p>
                  Trump wollte schon in den ersten hundert Tagen seiner Amtszeit
                  einen Plan zur Modernisierung der Infrastruktur vorstellen.
                  Das Land wartet immer noch auf den mehrere Hundert Milliarden
                  Dollar teuren Vorschlag zur Verbesserung von Strassen, Brücken
                  und Eisenbahnstrecken.
                </p>
                <div className='ui mini top attached steps'>
                  <div className='step'>
                    <i className='mini square outline icon' />
                    <div className='content'>
                      <div className='title'>Gesetzesentwurf</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Zustimmung Repräsentantenhaus</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Zustimmung Senat</div>
                    </div>
                  </div>
                  <div className='step'>
                    <i className='icon square outline' />
                    <div className='content'>
                      <div className='title'>Inkraftsetzung Gesetz</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='progress bar text ui divider' />
              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'progressbar7read'
                    })
                  }
                }}
              />
              <div
                className='ui left aligned fitted vertical segment steps-container'
                style={{ color: 'white' }}
              >
                <p className='progress bar text' style={{ marginBottom: '0' }}>
                  <p
                    className='progress bar text'
                    style={{
                      textAlign: 'left',
                      color: 'white',
                      marginBottom: '0'
                    }}
                  >
                    <strong>Bilanz der Aussen- und Wirtschaftspolitik</strong>
                  </p>In der Aussenpolitik tut sich die Trump-Administration
                  schwer. Das nordkoreanische Atom- und Raketenprogramm ist
                  weiterhin das vordringliche sicherheitspolitische Problem. Die
                  Angst vor einem Atomkrieg bleibt also der Welt erhalten. Trump
                  will Frieden zwischen Israelis und Palästinensern stiften.
                  Doch heizt er die Spannungen in der Region weiter an. Einen
                  konfrontativen Kurs verfolgt Trump auch in der Iran-Politik,
                  er droht mit dem Ende des Nuklear-Abkommens.
                </p>
                <br />
                <p className='progress bar text' style={{ marginBottom: '0' }}>
                  In der Wirtschaftspolitik vermeldet Trump laufend tatsächliche
                  und angebliche Erfolge seiner Regierung. Der Dow Jones
                  erreicht Rekordwerte, es entstehen neue Jobs, die Wirtschaft
                  brummt. Experten sind sich allerdings nicht darüber einig, ob
                  die amerikanische Wirtschaft dank Trump oder trotz ihm
                  erfolgreich unterwegs ist.
                </p>
              </div>
              <div
                className='ui left aligned fitted vertical segment steps-container'
                style={{ color: 'white' }}
              >
                <p className='progress bar text'>
                  <p
                    className='progress bar text'
                    style={{
                      textAlign: 'left',
                      color: 'white',
                      marginBottom: '0'
                    }}
                  >
                    <strong>Obamas Vermächtnis</strong>
                  </p>Der Politiker Trump ist untrennbar mit Barack Obama
                  verknüpft. Oft hat es den Eindruck, dass Präsident Trump am
                  liebsten das Gegenteil dessen macht oder sagt, was sein
                  Vorgänger tat. Im ersten Jahr hat Trump nicht nur viele
                  konservative Richter auf Lebenszeit eingesetzt, deren Urteile
                  zahlreiche von Obamas Errungenschaften einkassieren dürften.
                  Mindestens 800 Auflagen und Vorschriften wurden zurückgenommen
                  – stets zugunsten von Konzernen und Investoren und auf Kosten
                  von Natur und Verbrauchern.
                  <p className='progress bar text white'>
                    <strong>
                      Auflagen aus Obamas Amtszeit, die Trump rückgängig machte
                    </strong>
                  </p>
                  <img
                    className='image-padded'
                    src={require('./imgs/Obamaserbe.svg')}
                    width='100%'
                  />
                  <p className='progress bar text source'>
                    Quelle: Washington Post (Stand: 8.1.2018)
                  </p>
                </p>
              </div>
              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'progressbar8read'
                    })
                  }
                }}
              />
            </div>
          </div>
        </main>
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'question4read'
              })
            }
          }}
        />
        <main className='ui vertical very fitted inverted segment dark-grey background'>
          <div className='ui question container' id='question-5'>
            <h2>
              <span className='title-text'>5. {this.props.questions[4]}</span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
            <div
              className='ui text container no-marg'
              style={{ marginBottom: '50px' }}
            >
              <h3 className='trump quote' style={{ float: 'left' }}>
                «I'm going to be working for you. I'm not going to have time to
                go play golf.»
              </h3>
              <label className='quote label'>
                Donald J. Trump, August, 2016
              </label>
            </div>
            <div className='ui text container no-marg'>
              <div style={{ textAlign: 'center' }}>
                <img width='150px' src={require('./imgs/trump-golf-1.svg')} />
                <h3 className='big number'>an 91 Tagen</h3>
                <p className='big number legend'>besuchte er Golfclubs</p>
              </div>
              <p>
                Donald Trump hatte im Wahlkampf Präsident Barack Obama scharf
                kritisiert, weil er zu viel Golf spiele, «trotz aller Probleme,
                denen die USA gegenüberstehen». Dabei versprach Trump, er würde
                als Präsident so hart arbeiten, dass er das Weisse Haus nie
                verlassen würde. Tatsächlich hat Trump im ersten Amtsjahr an 91
                Tagen einen Golfclub besucht (Stand 19. Jan. 2018) und dabei
                deutlich mehr Golf gespielt als sein Vorgänger, wie die
                amerikanische Webseite{' '}
                <span>
                  <a
                    className='external link'
                    href='http://trumpgolfcount.com/'
                    target='_blank'
                  >
                    <i className='icon external' />«trumpgolfcount»
                  </a>
                </span>{' '}
                zeigt.
              </p>
              <div style={{ textAlign: 'center', marginTop: '30px' }}>
                <img width='150px' src={require('./imgs/trump-golf-3.svg')} />
                <h3 className='big number'>44 Mal</h3>
                <p className='big number legend'>
                  spielte er dabei Golf (mindestens)
                </p>
              </div>
              <p>
                Trumps Golf-Statistik stützt sich auf bestätigte Medienberichte,
                Communiqués aus dem Weissen Haus und andere Informationsquellen.
                Bestätigt ist, dass Trump bei den 91 Besuchen mindestens 44-mal
                Golf gespielt hat. Im ersten Amtsjahr spielte Obama 29-mal Golf.
                Das Weisse Haus stellt sich auf den Standpunkt, dass Golfen
                Trump zu einem besseren Präsidenten mache.
              </p>
              <div style={{ textAlign: 'center', marginTop: '30px' }}>
                <img width='150px' src={require('./imgs/trump-golf-2.svg')} />
                <h3 className='big number'>49'483'700 $</h3>
                <p className='big number legend'>
                  kostete das die Steuerzahler
                </p>
              </div>
              <p>
                Trumps Trips zu seinen Golfclubs in Mar-a-Lago (Florida) und
                Bedminster (New Jersey) haben den amerikanischen Steuerzahler
                bislang 49,5 Millionen Dollar gekostet. Der Betrag setzt sich
                zusammen aus den geschätzten Kosten für Flüge und Sicherheit für
                den Präsidenten und seine Familienangehörigen.
              </p>
            </div>
          </div>
        </main>
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'question5read'
              })
            }
          }}
        />
        <section
          className='ui fitted vertical segment dark-grey background'
          style={{ paddingTop: '0' }}
        >
          <div
            className='ui text container user-feedback-container no-marg'
            style={{ margin: '0 auto', paddingTop: '0px' }}
          >
            <UserFeedback
              inverted
              theme='simple'
              starIcon='star'
              articleId={this.props.articleId}
              starColor='#ffca18'
              fontColor='#ffffff'
              backgroundColor='#353535'
              starAmount='5'
              title='Wie bewerten Sie diese Geschichte?'
            />
          </div>
        </section>
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'pageBottom'
              })
            }
          }}
        />
        <footer className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui two column divided stackable inverted grid'>
              <div className='center aligned row teaser-section'>
                <a href='https://interaktiv.tagesanzeiger.ch'>
                  <img
                    src='https://interaktiv.tagesanzeiger.ch/inline-teaser.gif'
                    className='portfolio-teaser'
                  />
                </a>
              </div>
              <div className='stretched aligned row'>
                <div className='column'>
                  <table className='ui definition very basic small inverted infographic table'>
                    <tbody>
                      <tr>
                        <td>Idee und Umsetzung</td>
                        <td>Marc Fehr, Marc Brupbacher und Marina Bräm</td>
                      </tr>
                      <tr>
                        <td>Recherche, Text und Grafiken</td>
                        <td>
                          Vincenzo Capodici, Yannick Wiget, Micha Treuthardt und
                          Matthias Kolb
                        </td>
                      </tr>
                      <tr>
                        <td>Veröffentlicht</td>
                        <td>
                          <TimestampFormatter timestamp={1516428000 - 3600} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='column'>
                  <FeedbackMessage mailTo='interaktiv@tages-anzeiger.ch' />
                  <div className='ui fluid share center aligned container'>
                    <PolymorphicShareButtons
                      articleID={this.props.articleId}
                      hashtags={['TAGrafik', 'ddj']}
                      displayType={displayTypes.VERTICAL_BUTTONS}
                    />
                  </div>
                  <PolymorphicTracking articleId={this.props.articleId} />
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default hot(module)(AppComponent)



// WEBPACK FOOTER //
// ./src/components/main/index.js